import * as React from 'react';

import config from 'js/app/config';
import { FormattedMessage } from 'js/lib/coursera.react-intl';
import path from 'js/lib/path';

import { AlwaysLightMode } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/EmptyCompletedCoursesMessage';

const GRAD_ICON_SRC = path.join(config.url.assets, 'images/degree-home/grad_icon.svg');

class EmptyCompletedCoursesMessage extends React.Component {
  render() {
    return (
      <div className="rc-EmptyCompletedCoursesMessage">
        <AlwaysLightMode>
          <img className="grad-icon" src={GRAD_ICON_SRC} alt={_t('Grad Icon')} height="150" width="141" />
        </AlwaysLightMode>
        <div className="headline-2-text align-horizontal-center">
          <FormattedMessage message={_t('You are not enrolled in any courses yet')} />
        </div>
        <div className="body-1-text align-horizontal-center p-b-3">
          <FormattedMessage message={_t('When you enroll in courses in your degree program, they will appear here.')} />
        </div>
      </div>
    );
  }
}

export default EmptyCompletedCoursesMessage;
